import { alpha } from '@mui/material/styles'

export const commonDrawerPadding = theme => ({
  padding: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  boxSizing: 'border-box'
})

export const contentArea = {
  display: 'flex',
  minHeight: '400px',
  height: '100%',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
}

export const footerArea = theme => ({
  paddingTop: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  justifyContent: 'space-between',
  columnGap: '8px',
  alignItems: 'center'
})

export const searchInputStyles = {
  mb: 2.5,
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    fontFamily: ' Plus Jakarta Sans',
    fontWeight: 400,
    fontSize: '16px',
    border: '1px solid #E7E7EE',
    height: '40px',
    backgroundColor: alpha('#fff', 0.3)
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent'
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: alpha('#000', 0.23)
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'primary.main',
    borderWidth: '1px'
  }
}

export const chipContainerStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 1,
  maxHeight: 'calc(100vh - 400px)',
  overflowY: 'auto',
  padding: '2px'
}

export const chipStyles = selected => ({
  borderRadius: '12px',
  padding: '10px 12px',
  fontFamily: ' Plus Jakarta Sans',
  fontWeight: 400,
  fontSize: '16px',
  height: 'auto',
  color: selected ? '#FFFFFF' : '#76767F',
  backgroundColor: selected ? '#0246F8' : '#1B1B260F',
  border: 'none',
  '&:hover': {
    backgroundColor: selected ? '#0246F8' : '#1B1B260F'
  }
})

export const alertStyles = (theme, severity) => ({
  mt: 2,
  alignItems: 'center',
  fontWeight: 400,
  fontSize: 16,
  fontFamily: 'Plus Jakarta Sans',
  borderRadius: '16px',
  backgroundColor: severity === 'success' ? '#00BC6226' : '#FFF4F4',
  color: '#1B1B26',
  border: `1px solid ${severity === 'success' ? '#00BC624D' : '#D32F2F'}`
})

export const previewItemStyles = {
  display: 'flex',
  alignItems: 'center',
  mb: 1,
  '& .MuiSvgIcon-root': {
    mr: 1.5,
    fontSize: '1.25rem'
  }
}

export const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 400,
  bgcolor: 'background.paper',
  borderRadius: '16px',
  boxShadow: 24,
  p: 0,
  textAlign: 'center',
  outline: 'none'
}

export const modalHeaderStyle = theme => ({
  padding: theme.spacing(2, 3),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.divider}`
})

export const modalContentStyle = theme => ({
  padding: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
})
export const baseButtonStyles = {
  width: '100%',
  borderRadius: '16px',
  fontFamily: 'Plus Jakarta Sans',
  fontWeight: 400,
  fontSize: '16px',
  padding: '8px 8px',
  boxShadow: 'none',
  textTransform: 'none'
}
export const containedBottomButton = {
  ...baseButtonStyles,
  backgroundColor: '#0246F8',
  color: '#fff'
}

export const outlinedBottomButton = {
  ...baseButtonStyles,
  color: '#1B1B26',
  backgroundColor: '#fff',
  border: '1px solid #D0D0D8',
  '&:hover': {
    backgroundColor: '#D0D0D8'
  }
}
export const campaignPreviewCardStyles = {
  borderRadius: '16px',
  border: '4px solid #000000',
  borderTopLeftRadius: '16px',
  borderTopRightRadius: '16px',
  borderBottomLeftRadius: '0px',
  borderBottomRightRadius: '0px',
  borderBottom: `none`,
  padding: '24px 24px 0',
  width: '450px',
  backgroundColor: '#FFFFFF',
  boxShadow: 'none'
}

export const campaignInfoItemStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  columnGap: '12px',
  padding: '12px 0px',
  borderBottom: '1px solid #E7E8EA',
  '&:last-of-type': { borderBottom: 'none' }
}

export const campaignTitleStyles = {
  fontSize: '20px',
  fontWeight: 600,
  fontFamily: 'Plus Jakarta Sans',
  color: '#1B1B26',
  marginBottom: '24px'
}

export const fieldLabelStyles = {
  fontSize: '16px',
  fontWeight: 400,
  fontFamily: 'Plus Jakarta Sans',
  color: '#76767D',
  textTransform: 'capitalize',
  marginBottom: '4px',
  letterSpacing: '0.5px'
}

export const fieldValueStyles = {
  fontSize: '16px',
  fontWeight: 600,
  fontFamily: 'Plus Jakarta Sans',
  color: '#1B1B26',
  lineHeight: '20px'
}

export const dateSelectStyles = {
  width: 240,
  marginRight: '20px',
  backgroundColor: '#ffffff',
  border: 'none',

  '& .MuiOutlinedInput-root': {
    fontSize: 16,
    fontWeight: 600,
    fontFamily: 'Plus Jakarta Sans',
    borderRadius: '10px',
    border: 'none'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent'
  },
  '& .MuiOutlinedInput-input': {
    padding: '4px 4px',
    border: 'none'
  }
}

export const campaignPreviewWrapperStyles = {
  position: 'relative',
  width: '100%',
  minHeight: '400px',
  height: ' 100%',
  display: 'flex',
  flexDirection: 'column'
}

export const gradientBackgroundStyles = {
  position: 'absolute',
  top: '24px',
  left: '50%',
  transform: 'translateX(-50%)',
  width: '650px',
  height: '290px',
  background: 'linear-gradient(90deg, #667EEA 0%, #764BA2 100%)',
  borderRadius: '12px',
  opacity: 1,
  zIndex: 1,
  overflow: 'hidden'
}

export const patternImageStyles = position => ({
  position: 'absolute',
  width: '150px',
  height: 'auto',
  zIndex: 1,
  ...(position === 'right' && { top: -10, right: -10 }),
  ...(position === 'left' && { bottom: -10, left: -10 })
})

export const contentWrapperStyles = {
  top: -48,
  position: 'relative',
  zIndex: 2,
  display: 'flex',
  flexDirection: 'column',
  padding: '0 24px 0 24px'
}
